import React from "react";

import { Icon } from "@partials";
import { ExchangeRatesECBDifference, ExchangeRatesECBDifferenceLink } from "../types";

type RatesKBvsECBProps = {
  exchangeRatesECBDifference: ExchangeRatesECBDifference & ExchangeRatesECBDifferenceLink;
  inputDate: string;
  iconsList: any;
};

const RatesKBvsECB: React.FC<RatesKBvsECBProps> = ({
  exchangeRatesECBDifference,
  inputDate,
  iconsList,
}) => {
  if (!exchangeRatesECBDifference.isVisible) return null;

  const { arrowRight } = iconsList;

  return (
    <div className="mb-12">
      <p className="mb-6 text-2xl">{exchangeRatesECBDifference.title}</p>
      {/* eslint-disable-next-line react/no-danger */}
      <p className="mb-6" dangerouslySetInnerHTML={{ __html: exchangeRatesECBDifference.intro }} />
      <span className="cursor-pointer text-red-corporate hover:underline">
        <a
          href={`${exchangeRatesECBDifference.link.href}${inputDate}`}
          target={exchangeRatesECBDifference.link.target}
          data-testid="rates-ecb-link"
        >
          {exchangeRatesECBDifference.link.innerHtml}
        </a>
        <Icon
          name={arrowRight.name}
          viewBox={arrowRight.viewbox}
          alt={arrowRight.alt}
          svg={arrowRight.svg}
          className="inline h-6 w-6 fill-red-corporate"
        />
      </span>
    </div>
  );
};

export default RatesKBvsECB;
